export default "/assets/images/mila-feed-15-thumbnail.40023f6462a6800b.jpg";